import React from 'react';
import styled from 'styled-components';

// Awards and Partners Data - Easy to add more items!
const awardsPartnersData = [
  {
    id: 1,
    logo: "/nycbba24_winner+JPG+Seal-1.webp",
    alt: "NYC Big Book Award",
    caption: "NYC Big Book Award — Middle Grade (Future Hack)",
    type: "award",
    link: "https://www.nycbigbookaward.com/2024winners/9781938447617"
  },
  {
    id: 2,
    logo: "/images.png",
    alt: "Neighborhood Forest",
    caption: "Neighborhood Forest – Partner",
    type: "partner",
    link: "https://www.neighborhoodforest.org/"
  },
  {
    id: 3,
    logo: "/unesco-logo-png_seeklogo-349497.png",
    alt: "UNESCO",
    caption: "UNESCO Greening Education Partnership — Partner",
    type: "partner",
    link: "https://www.unesco.org/en/sustainable-development/education/greening-future"
  },
  {
    id: 4,
    logo: "/Nature.webp",
    alt: "Nature",
    caption: "The Nature Generation ",
    type: "partner",
    link: "https://natgen.org/"
  },
  {
    id: 5,
    logo: "/slj.webp",
    alt: "SLJ",
    caption: "School Library Journal",
    type: "award",
    link: "https://teenlibrariantoolbox.com/2024/04/17/from-page-to-planet-inspiring-young-environmental-champions-through-fiction-a-guest-post-by-dana-klisanin/"
  },
  {
    id: 6,
    logo: "wiki.webp",
    alt: "Wiki",
    caption: "Wiki Observatory",
    type: "award",
    link: "https://observatory.wiki/How_Science_Fiction_Can_Inspire_Environmentalism_and_Climate_Action"
  },
  {
    id: 7,
    logo: "/editsvg.svg",
    alt: "COUNTERPUNCH",
    caption: "CouterPunch",
    type: "award",
    link: "https://www.counterpunch.org/2024/07/05/how-science-fiction-can-inspire-climate-activism"
  },
  {
    id: 8,
    logo: "/DG-Logo-Yellow-non-ret.png",
    alt: "Daily Guardian",
    caption: "Daily Guardian",
    type: "award",
    link: "https://dailyguardian.com.ph/how-science-fiction-can-inspire-environmentalism-and-climate-action/"
  },
];

const AwardsSection = () => {
  const handleCardClick = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Wrapper>
      <Content>
        <Title>Awards, Partners & Press</Title>
        <Subtitle>Recognizing excellence and collaboration</Subtitle>
        <PartnersRow>
          {awardsPartnersData.map((item) => (
            <PartnerItem 
              key={item.id}
              onClick={() => handleCardClick(item.link)}
              $hasLink={!!item.link}
            >
              <LogoContainer>
                <Logo src={item.logo} alt={item.alt} />
              </LogoContainer>
              <Caption>{item.caption}</Caption>
            </PartnerItem>
          ))}
        </PartnersRow>
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  width: 100vw;
  background: linear-gradient(120deg, #eaf1fb 0%, #e3eafc 40%, #dbeafe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  padding: 0;
  @media (max-width: 768px) {
    padding: 0;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media (max-width: 1280px) {
    padding: 55px 20px;
    gap: 28px;
  }

  @media (max-width: 1024px) {
    padding: 50px 20px;
    gap: 26px;
  }

  @media (max-width: 900px) {
    padding: 45px 18px;
    gap: 24px;
  }

  @media (max-width: 768px) {
    padding: 40px 16px;
    gap: 22px;
  }

  @media (max-width: 640px) {
    padding: 36px 14px;
    gap: 20px;
  }

  @media (max-width: 480px) {
    padding: 32px 12px;
    gap: 18px;
  }

  @media (max-width: 375px) {
    padding: 28px 10px;
    gap: 16px;
  }
`;

const Title = styled.h2`
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1.1;
  margin: 0;
  background: linear-gradient(90deg, #1e3a8a 0%, #2563eb 60%, #60a5fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-align: center;
  @media (max-width: 1024px) {
    font-size: 2rem;
  }
  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.18rem;
  color: #334155;
  line-height: 1.7;
  font-weight: 400;
  margin: 0;
  margin-bottom: 25px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const PartnersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 24px;
  width: 100%;
  max-width: 900px;

  @media (max-width: 1280px) {
    gap: 22px;
    grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  }

  @media (max-width: 1024px) {
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  }

  @media (max-width: 900px) {
    gap: 18px;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }

  @media (max-width: 768px) {
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }

  @media (max-width: 640px) {
    gap: 14px;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
  }

  @media (max-width: 480px) {
    gap: 12px;
    grid-template-columns: 1fr;
    max-width: 240px;
  }

  @media (max-width: 375px) {
    gap: 10px;
  }
`;

const PartnerItem = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 8px rgba(30, 64, 175, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: ${props => props.$hasLink ? 'pointer' : 'default'};
  
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow: 0 6px 20px rgba(30, 64, 175, 0.25);
  }

  @media (max-width: 768px) {
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    border-radius: 8px;
  }
`;

const LogoContainer = styled.div`
  width: 100%;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  padding: 18px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 14px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

const Logo = styled.img`
  width: 100%;
`;

const Caption = styled.div`
  font-size: 0.85rem;
  color: #334155;
  padding: 10px 8px 12px 8px;
  text-align: center;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 8px 6px 10px 6px;
  }

  @media (max-width: 480px) {
    font-size: 0.75rem;
    padding: 8px 6px 10px 6px;
  }
`;

export default AwardsSection;